/* CWK Hand — draws annotations in the angular marker style of the hand-drawn CWK logo
   (diamond O, "<" C, "|>" D). Every glyph is re-jittered, so no two letters repeat.
   Markup: <p data-cwk-hand="marker|chalk|pencil" data-underline="2" data-align="left">Text<br>Line two</p> */
(function () {
  // Single-stroke skeletons. Cap height = 100 units, baseline y = 100. [advance, strokes...]
  var G = {
    A: [40, [[0, 100], [20, 0], [40, 100]], [[8, 64], [34, 61]]],
    B: [46, [[0, 100], [2, 0]], [[2, 0], [36, 6], [42, 24], [6, 48], [42, 60], [46, 84], [30, 100], [0, 98]]],
    C: [50, [[46, 2], [23, 26], [2, 52], [25, 77], [50, 98]]],
    D: [46, [[0, 0], [2, 100]], [[0, 2], [44, 52], [4, 100]]],
    E: [42, [[40, 0], [0, 4], [2, 100], [42, 96]], [[2, 50], [36, 46]]],
    F: [42, [[42, 0], [0, 4], [2, 100]], [[2, 48], [34, 45]]],
    G: [52, [[48, 4], [2, 50], [46, 98], [52, 60], [28, 60]]],
    H: [46, [[0, 0], [2, 100]], [[46, 0], [44, 100]], [[2, 52], [45, 48]]],
    I: [4, [[2, 0], [0, 100]]],
    J: [38, [[38, 0], [36, 82], [18, 100], [0, 84]]],
    K: [48, [[0, 0], [2, 100]], [[44, 0], [4, 54], [48, 100]]],
    L: [30, [[3, 0], [0, 100], [28, 94]]],
    M: [52, [[0, 100], [4, 0], [26, 58], [48, 0], [52, 100]]],
    N: [46, [[0, 100], [2, 0], [44, 100], [46, 0]]],
    O: [48, [[22, 2], [0, 52], [24, 100], [48, 48], [22, 0], [18, 7]]],
    P: [44, [[0, 100], [2, 0]], [[2, 0], [40, 12], [42, 34], [2, 52]]],
    Q: [52, [[22, 2], [0, 52], [24, 100], [48, 48], [22, 0], [18, 7]], [[30, 74], [54, 104]]],
    R: [52, [[0, 100], [2, 0]], [[2, 0], [40, 14], [42, 34], [4, 52], [52, 100]]],
    S: [38, [[36, 8], [22, 0], [4, 8], [2, 32], [33, 57], [38, 82], [20, 100], [0, 92]]],
    T: [56, [[0, 6], [56, 0]], [[28, 3], [27, 100]]],
    U: [44, [[0, 0], [2, 80], [22, 100], [42, 80], [44, 0]]],
    V: [48, [[0, 0], [24, 100], [48, 0]]],
    W: [60, [[0, 0], [8, 100], [30, 38], [48, 100], [60, 2]]],
    X: [46, [[0, 0], [46, 100]], [[46, 0], [0, 100]]],
    Y: [48, [[0, 0], [24, 50], [48, 0]], [[24, 50], [23, 100]]],
    Z: [48, [[0, 4], [44, 0], [2, 100], [48, 96]]],
    '0': [42, [[20, 0], [0, 30], [2, 72], [22, 100], [42, 70], [40, 28], [20, 0]]],
    '1': [26, [[6, 16], [22, 0], [21, 100]]],
    '2': [44, [[0, 16], [18, 0], [38, 6], [40, 28], [0, 100], [44, 96]]],
    '3': [42, [[0, 4], [40, 0], [14, 42], [40, 56], [38, 88], [18, 100], [0, 92]]],
    '4': [46, [[34, 100], [34, 0], [0, 66], [46, 63]]],
    '5': [44, [[40, 0], [6, 2], [2, 42], [34, 44], [42, 76], [22, 100], [0, 92]]],
    '6': [44, [[38, 2], [4, 52], [8, 90], [26, 100], [42, 76], [28, 52], [6, 62]]],
    '7': [44, [[0, 4], [44, 0], [14, 100]]],
    '8': [44, [[22, 48], [4, 24], [20, 0], [40, 22], [22, 48], [2, 72], [22, 100], [44, 74], [22, 48]]],
    '9': [42, [[40, 40], [18, 50], [2, 26], [20, 0], [40, 18], [38, 100]]],
    '.': [3, [[1, 95], [2, 99]]],
    ',': [5, [[3, 92], [-2, 112]]],
    "'": [3, [[2, 0], [1, 16]]],
    '!': [4, [[2, 0], [1, 72]], [[1, 95], [2, 99]]],
    '?': [36, [[0, 12], [16, 0], [36, 8], [36, 30], [18, 52], [18, 72]], [[18, 95], [19, 99]]],
    '-': [24, [[0, 56], [24, 53]]],
    '–': [34, [[0, 56], [34, 53]]],
    '—': [56, [[0, 56], [56, 52]]],
    '/': [34, [[34, 0], [0, 100]]],
    ':': [3, [[1, 38], [2, 42]], [[1, 95], [2, 99]]],
    '×': [30, [[0, 36], [30, 72]], [[30, 36], [0, 72]]],
    '°': [12, [[6, 0], [0, 6], [6, 12], [12, 6], [6, 0]]],
    '+': [34, [[0, 56], [34, 53]], [[17, 36], [18, 74]]],
    '&': [48, [[48, 100], [8, 38], [16, 4], [32, 10], [32, 28], [0, 72], [16, 100], [34, 96], [48, 62]]],
    '(': [16, [[16, 0], [2, 50], [16, 100]]],
    ')': [16, [[0, 0], [14, 50], [0, 100]]],
    '↓': [36, [[18, 0], [19, 100]], [[2, 74], [19, 100], [36, 72]]],
    '→': [60, [[0, 54], [60, 50]], [[36, 30], [60, 50], [38, 72]]],
    '↘': [50, [[2, 4], [50, 98]], [[18, 96], [50, 98], [48, 66]]]
  };
  G['’'] = G["'"];
  G['‘'] = G["'"];
  var STYLES = {
    marker: { weight: 9.4, filter: 'cwk-hand-marker' },
    chalk: { weight: 8.5, filter: 'cwk-hand-chalk' },
    pencil: { weight: 4.2, filter: 'cwk-hand-pencil' },
    scratch: { weight: 5.6, filter: 'cwk-hand-pencil' }
  };
  var TRACK = 12, SPACE = 34, LINE = 124, PAD = 14;

  function hash(s) {
    var h = 2166136261;
    for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }
  function rng(seed) {
    return function () {
      seed |= 0; seed = (seed + 0x6D2B79F5) | 0;
      var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function strokePath(pts, r) {
    // Subdivide long segments, bow them slightly and overshoot the ends like a quick marker line.
    var out = [];
    for (var i = 0; i < pts.length - 1; i++) {
      var a = pts[i], b = pts[i + 1];
      var dx = b[0] - a[0], dy = b[1] - a[1], len = Math.sqrt(dx * dx + dy * dy) || 1;
      var n = Math.max(1, Math.round(len / 18));
      var bow = (r() - 0.5) * Math.min(4, len * 0.05);
      var nx = -dy / len, ny = dx / len;
      for (var k = 0; k < n; k++) {
        var t = k / n, s = Math.sin(Math.PI * t) * bow;
        out.push([a[0] + dx * t + nx * s, a[1] + dy * t + ny * s]);
      }
    }
    out.push(pts[pts.length - 1].slice());
    if (out.length > 1) {
      var o1 = (r() * 5), o2 = (r() * 6);
      var p0 = out[0], p1 = out[1], q0 = out[out.length - 1], q1 = out[out.length - 2];
      var l1 = Math.hypot(p0[0] - p1[0], p0[1] - p1[1]) || 1, l2 = Math.hypot(q0[0] - q1[0], q0[1] - q1[1]) || 1;
      out[0] = [p0[0] + (p0[0] - p1[0]) / l1 * o1, p0[1] + (p0[1] - p1[1]) / l1 * o1];
      out[out.length - 1] = [q0[0] + (q0[0] - q1[0]) / l2 * o2, q0[1] + (q0[1] - q1[1]) / l2 * o2];
    }
    var d = '';
    for (var j = 0; j < out.length; j++) d += (j ? 'L' : 'M') + out[j][0].toFixed(1) + ' ' + out[j][1].toFixed(1);
    return d;
  }

  function glyph(ch, x0, y0, r, paths) {
    var g = G[ch];
    if (!g) return SPACE * 0.6;
    var rot = (r() - 0.5) * 7 * Math.PI / 180;
    var skew = (r() - 0.62) * 0.09;
    var sx = 0.85 + r() * 0.18, sy = 0.93 + r() * 0.14;
    var dy = (r() - 0.5) * 6;
    var cx = g[0] / 2, cy = 50;
    var cos = Math.cos(rot), sin = Math.sin(rot);
    for (var s = 1; s < g.length; s++) {
      var pts = g[s].map(function (p) {
        var x = (p[0] - cx) * sx + (p[1] - cy) * skew + (r() - 0.5) * 3.2;
        var y = (p[1] - cy) * sy + (r() - 0.5) * 3.2;
        return [x0 + cx * sx + x * cos - y * sin, y0 + cy + dy + x * sin + y * cos];
      });
      paths.push(strokePath(pts, r));
    }
    return g[0] * sx;
  }

  function render(el) {
    if (el.__cwkHand) return;
    var style = STYLES[el.getAttribute('data-cwk-hand')] || STYLES.marker;
    var raw = el.innerHTML.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]+>/g, '');
    var tmp = document.createElement('textarea');
    tmp.innerHTML = raw;
    var text = tmp.value.trim();
    if (!text) return;
    var lines = text.toUpperCase().split(/\n+/).map(function (l) { return l.trim(); });
    var r = rng(hash(text + (el.getAttribute('data-seed') || '')));
    var align = el.getAttribute('data-align') || 'left';
    var paths = [], widths = [], linePaths = [];
    lines.forEach(function (line, li) {
      var lp = [], x = 0, y = li * LINE;
      for (var i = 0; i < line.length; i++) {
        var ch = line[i];
        if (ch === ' ') { x += SPACE + (r() - 0.5) * 8; continue; }
        x += glyph(ch, x, y, r, lp) + TRACK + (r() - 0.5) * 7;
      }
      widths.push(Math.max(0, x - TRACK));
      linePaths.push(lp);
    });
    var W = Math.max.apply(null, widths);
    var underline = parseInt(el.getAttribute('data-underline') || '0', 10);
    linePaths.forEach(function (lp, li) {
      var off = align === 'center' ? (W - widths[li]) / 2 : align === 'right' ? W - widths[li] : (r() - 0.3) * 10;
      var slope = (r() - 0.5) * 2.4;
      paths.push('<g transform="translate(' + (PAD + off).toFixed(1) + ' ' + PAD + ') rotate(' + slope.toFixed(2) + ' 0 ' + (li * LINE + 50) + ')"><path d="' + lp.join('') + '"/></g>');
    });
    var H = (lines.length - 1) * LINE + 100;
    if (underline > 0) {
      var last = widths.length - 1, lw = widths[last];
      var lx = align === 'center' ? (W - lw) / 2 : align === 'right' ? W - lw : 0;
      for (var u = 0; u < underline; u++) {
        var uy = H + 16 + u * 15;
        var ux0 = lx - 6 + r() * 10, ux1 = lx + lw + 4 - r() * 16;
        var pts = [[ux0, uy + (r() - 0.5) * 4], [(ux0 + ux1) / 2, uy + 3 + (r() - 0.5) * 6], [ux1, uy - 3 + (r() - 0.5) * 6]];
        paths.push('<g transform="translate(' + PAD + ' ' + PAD + ')"><path d="' + strokePath(pts, r) + '"/></g>');
      }
      H += 16 + underline * 15;
    }
    var VW = W + PAD * 2, VH = H + PAD * 2;
    var svg = '<svg class="cwk-hand__svg" viewBox="0 0 ' + VW.toFixed(0) + ' ' + VH.toFixed(0) + '" style="width:' + (VW / 100).toFixed(3) + 'em;height:' + (VH / 100).toFixed(3) + 'em" aria-hidden="true" focusable="false">' +
      '<g fill="none" stroke="currentColor" stroke-width="' + style.weight + '" stroke-linecap="round" stroke-linejoin="round" filter="url(#' + style.filter + ')">' + paths.join('') + '</g></svg>';
    el.__cwkHand = true;
    el.innerHTML = '<span class="cwk-hand__text">' + el.innerHTML + '</span>' + svg;
    el.classList.add('is-handed');
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-cwk-hand]').forEach(render);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
